import { JackGirderConnection, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

export const CarriedComponentsSchema = new ModelSchema<JackGirderConnection>('jackGirderConnection', {
  category: ModelCategory.ComponentDesignData,

  // The pluralName must be manually set because doesn't match type of this item (jackGirderConnection).
  pluralName: 'Carried Components',

  // The actual display depends on the name of the carried truss that is supported by the girder, so the design client's
  //   navigation panel contains a special case to calculate the name at runtime.
  displayName: 'Girder Connection',

  properties: {},
});
